import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { CompanyRegistrationService } from '../dataServices/company-registration-service';

/**
 * Keeps the company-registration page reachable only while this deployment has no company.
 *
 * One deployment serves one customer, so the first visitor registers the company and becomes its
 * admin; everyone after that joins it as an employee. Hiding the "Register your company" link is not
 * enough on its own — the route is anonymous and someone can navigate to it directly or from a
 * bookmark, which is why this guard exists alongside the backend check in
 * CompanyRegistrationService.CreateCompanyRegistrationAsync.
 *
 * If the check itself fails (API unreachable) the user is sent to /login rather than into a
 * registration flow whose submit is guaranteed to be rejected by the backend.
 */
export const companyRegistrationOpenGuard: CanActivateFn = () => {
  const router = inject(Router);
  const registrationService = inject(CompanyRegistrationService);

  return registrationService.isRegistrationOpen().pipe(
    map((res) =>
      res?.status && res.data ? true : router.createUrlTree(['/login']),
    ),
    catchError(() => of(router.createUrlTree(['/login']))),
  );
};
